import { allergies } from "../components/enum/formEnum";


export const serviceDetailSchema = {
	title: "Service Details",
	type: "object",
	required: [
		"variableFlexibleServices",
		"clientCareNeeds",
		"behaviorCognition",
		"additionalInformation",
	],
	properties: {
		variableFlexibleServices: {
			type: "object",
			title: "Individualized Service Plan",
			description: "Select the types of assistance needed",
			properties: {
				bathing: { type: "boolean", default: false, title: "Bathing", description: "Help with bathing and personal hygiene" },
				eating: { type: "boolean", default: false, title: "Eating", description: "Is meal time assistance required?" },
				toileting: { type: "boolean", default: false, title: "Toileting", description: "Help with bathroom needs" },
				mealPreparation: { type: "boolean", default: false, title: "Meal Preparation", description: "Help with preparing meals and snacks" },
				dressingGrooming: { type: "boolean", default: false, title: "Dressing & Grooming", description: "Help with dressing and grooming" },
				housework: { type: "boolean", default: false, title: "Light Housekeeping", description: "" },
				companionship: { type: "boolean", default: false, title: "Companionship", description: "Provide companionship" },
				transportationNeeded: { type: "boolean", default: false, title: "Transportation Needed", description: "Does the client need to be driven?" },
				other: { type: "boolean", default: false, title: "Other" },
			},
			dependencies: {
				eating: {
					oneOf: [
						{
							properties: {
								eating: { const: true },
								"__spacer_assist_note": {
									type: "null",
									title: "",
								},
								'assistanceEatingNotes': {
									type: "string",
									title: "Eating Assistance Notes",
									description: "Provide additional details about meal time assistance.",
									maxLength: 500,
									errorMessage: {
										required: "Please enter assistance eating note",
										maxLength: "Assistance eating note must be 500 characters or less",
									},
								},
							},
							required: ["assistanceEatingNotes"],
						},
						{
							properties: {
								eating: { const: false },
							},
						},
					],
				},

				transportationNeeded: {
					default: true,
					oneOf: [
						{
							properties: {
								transportationNeeded: { const: true },
								vehiclePreference: {
									type: "string",
									title: "Vehicle Preference",
									enum: ["caregiver", "client", "either", "none"],

									default: "none"
								}
							},
							required: ["vehiclePreference"]
						},
						{
							properties: {
								transportationNeeded: { const: false }
							}
						}
					]
				},
				other: {
					oneOf: [
						{
							properties: {
								other: { const: true },
								'specifyOther': {
									type: "string",
									title: "Please specify other",
									description: "",
									maxLength: 500,
									errorMessage: {
										required: "Please provide details for other",
										maxLength: "Other must not exceed 500 characters",
									},
								},
							},
							required: ["specifyOther"],
						},
						{
							properties: {
								other: { const: false },
							},
						},
					],
				},

			},
		},

		clientCareNeeds: {
			type: "object",
			title: "Client Care Needs",
			required: [
				"medicalDiagnosis",
				"fallRisk",
				"continence",
				"vision",
				"hearing",
				"speech",
				"oxygenDependent",
				"isShoweringAssistance",
				"isMedicationReminders",
				"swallowing",
				"dental",
				"isOralHygieneAssistance",
				"isMealtimeAssistance",
				"walker",
			],
			properties: {
				medicalDiagnosis: {
					type: "string", title: "Medical Diagnosis, recent hospitalizations, or injuries",
					maxLength: 500,
					errorMessage: {
						required: "Please enter medical diagnosis/recent hospitalization or falls",
						maxLength: " Medical diagnosis/recent hospitalization or falls must be 500 characters or less",
					},
				},
				fallRisk: {
					type: "string", title: "Fall Risk", enum: ["none", "low", "medium", "high"], default: "none", errorMessage: {
						required: "Please select fall risk",
					},
				},
				continence: {
					type: "string", title: "Continence", enum: ["continent", "occasional", "incontinent"], default: "continent", errorMessage: {
						required: "Please select continence",
					}
				},
				vision: {
					type: "string", title: "Vision", enum: ["normal", "impaired", "blind"], default: "normal", errorMessage: {
						required: "Please select vision",
					}
				},
				hearing: {

					type: "string", title: "Hearing", enum: ["normal", "mild", "moderate", "severe", "deaf"], default: "normal", errorMessage: {
						required: "Please select hearing",
					}
				},
				speech: {
					type: "string", title: "Speech", enum: ["normal", "impaired", "nonverbal"], default: "normal", errorMessage: {
						required: "Please select speech",
					}
				},
				oxygenDependent: {
					type: "string", title: "Oxygen Dependent", enum: ["yes", "no"], errorMessage: {
						required: "Please select yes or no",
					}
				},
				isShoweringAssistance: {
					type: "string", title: "Is showering assistance required?", enum: ["Yes", "No"], errorMessage: {
						required: "Please select showering assistance",
					}
				},
				isOralHygieneAssistance: {
					type: "string", title: "Is oral hygiene assistance required?", enum: ["Yes", "No"], errorMessage: {
						required: "Please select oral hygiene assistance",
					}
				},
				walker: {
					type: "string", title: "Uses a walker or cane", enum: ["Yes", "No"], errorMessage: {
						required: "Please select walker or cane",
					}
				},
				isMealtimeAssistance: {
					type: "string", title: "Is mealtime assistance required?", enum: ["Yes", "No"], errorMessage: {
						required: "Please select mealtime assistance",
					}
				},
				isMedicationReminders: {
					type: "string", title: "Are medication reminders required?", enum: ["Yes", "No"], errorMessage: {
						required: "Please select medication reminders",
					}
				},
				swallowing: {
					type: "string", title: "Swallowing", enum: ["Good", "Poor", "Other"], errorMessage: {
						required: "Please select swallowing",
					}
				},
				dental: {
					type: "string", title: "Dental", enum: ["Good", "Poor", "Dentures"], errorMessage: {
						required: "Please select dental",
					}
				},
			},
			dependencies: {
				isShoweringAssistance: {
					oneOf: [
						{
							properties: {
								isShoweringAssistance: { const: "Yes" },
								isShoweringAssistanceLevel: {
									type: "string",
									title: "What level of showering assistance is required?",
									enum: ["StandBy", "Assist In And Out", "Total"],
									errorMessage: {
										required: "Please select showering assistance",
									},
								},
							},
							required: ["isShoweringAssistanceLevel"],
						},
						{
							properties: {
								isShoweringAssistance: { const: "No" },
							},
						},
					],
				},
				isMedicationReminders: {
					oneOf: [
						{
							properties: {
								isMedicationReminders: { const: "Yes" },
								isMedicationRemindersResponse: {
									type: "string",
									title: "Who is currently responsible?",
									errorMessage: {
										required: "Please specify who is currently responsible",
									},
								},
							},
							required: ["isMedicationRemindersResponse"],
						},
						{
							properties: {
								isMedicationReminders: { const: "No" },
							},
						},
					],
				},
				swallowing: {
					oneOf: [
						{
							properties: {
								swallowing: { const: "Other" },
								swallowingOther: {
									type: "string",
									title: "Please specify other",
									maxLength: 500,
									errorMessage: {
										required: "Please enter specify other",
										maxLength: "Specify other must be 500 characters or less",
									},
								},
							},
							required: ["swallowingOther"],
						},
						{
							properties: {
								swallowing: { enum: ["Good", "Poor"] },

							},
						},
					],
				},
				isMealtimeAssistance: {
					oneOf: [
						{
							properties: {
								isMealtimeAssistance: { const: "Yes" },
								isMealtimeAssistanceLevel: {
									type: "array",
									title: "What level of mealtime assistance is required?",
									uniqueItems: true,
									minItems: 1,
									items: {
										type: "string",
										enum: ["Preparation", "Cooking", "Feeding"],
									},
									errorMessage: {
										required: "At least one select mealtime assistance level",
										minItems: "At least one select mealtime assistance level",
									},
								},

							},
							required: ["isMealtimeAssistanceLevel"],
						},
						{
							properties: {
								isMealtimeAssistance: { const: "No" },
							},
						},
					],
				},
			},
		},

		mobilityAssistanceHeading: {
			type: "object",
			title: "Mobility & Assistance",
			properties: {
				usesWheelchair: { type: "boolean", title: "Uses Wheelchair", description: "Client requires or uses a wheelchair for mobility" },
				mobilityAssistance: {
					type: "string",
					title: "Mobility Assistance",
					enum: ["none", "wheelchair", "walker", "cane", "crutches", "guideDog", "both"],
					default: "none",
				},
			},
		},
		behaviorCognition: {
			type: "object",
			title: "Behavior & Cognition",
			description: "Identify any behavioral or cognitive considerations",
			properties: {
				confusion: { type: "boolean", title: "Confusion", description: "Shows signs of confusion or disorientation" },
				agitation: { type: "boolean", title: "Agitation", description: "Displays restlessness or agitation" },
				suspicious: { type: "boolean", title: "Suspicious", description: "Shows suspicious or paranoid behavior" },
				upAtNight: { type: "boolean", title: "Up at Night", description: "Active during nighttime hours" },
				withdrawn: { type: "boolean", title: "Withdrawn", description: "Socially withdrawn or isolated" },
				wanders: { type: "boolean", title: "Wanders", description: "Tendency to wander or get lost" },
				combative: { type: "boolean", title: "Combative", description: "Shows aggressive or combative behavior" }
			},
			dependencies: {
				confusion: {
					oneOf: [
						{
							properties: {
								confusion: { const: true },
								confusionNotes: {
									type: "string",
									title: "Confusion Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Confusion notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { confusion: { const: false } } }
					]
				},
				agitation: {
					oneOf: [
						{
							properties: {
								agitation: { const: true },
								agitationNotes: {
									type: "string",
									title: "Agitation Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Agitation notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { agitation: { const: false } } }
					]
				},
				suspicious: {
					oneOf: [
						{
							properties: {
								suspicious: { const: true },
								suspiciousNotes: {
									type: "string",
									title: "Suspicious Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Suspicious notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { suspicious: { const: false } } }
					]
				},
				upAtNight: {
					oneOf: [
						{
							properties: {
								upAtNight: { const: true },
								upAtNightNotes: {
									type: "string",
									title: "Up at Night Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Up at Night notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { upAtNight: { const: false } } }
					]
				},
				withdrawn: {
					oneOf: [
						{
							properties: {
								withdrawn: { const: true },
								withdrawnNotes: {
									type: "string",
									title: "Withdrawn Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Withdrawn notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { withdrawn: { const: false } } }
					]
				},
				wanders: {
					oneOf: [
						{
							properties: {
								wanders: { const: true },
								wandersNotes: {
									type: "string",
									title: "Wanders Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Wanders notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { wanders: { const: false } } }
					]
				},
				combative: {
					oneOf: [
						{
							properties: {
								combative: { const: true },
								combativeNotes: {
									type: "string",
									title: "Combative Notes",
									maxLength: 100,
									errorMessage: {
										maxLength: "Combative notes must be under 100 characters"
									}
								}
							}
						},
						{ properties: { combative: { const: false } } }
					]
				}
			}
		},
		additionalInformation: {
			type: "object",
			title: "Additional Information",
			properties: {
				petsPresent: { type: "boolean", title: "Pets Present", description: "Are there any pets at the service location?" },
				smokingEnvironment: { type: "boolean", title: "Smoking Environment", description: "Is there a smoker at the service address?" },
				longTermCareInsurance: { type: "boolean", title: "Long-Term Care Insurance", description: "Does the client have a long-term care insurance policy?" },
				// policyNumber: { type: "string", title: "Policy Number" },

				firearmsPresent: { type: "boolean", title: "Firearms Present", description: "Are there any firearms at the service address?" },
				allergies: {
					type: "array",
					title: "Allergies",
					items: {
						type: "string",
						enum: allergies,
					},
					uniqueItems: true
				},

			},
			dependencies: {
				allergies: {
					oneOf: [
						{
							properties: {
								allergies: {
									type: "array",
									minItems: 1
								},
								allergiesNote: {
									type: "string",
									title: "Allergies Note",
									maxLength: 500,
									errorMessage: {
										maxLength: "Allergies note must be under 500 characters",
										required: "Allergies note is required"
									}
								}
							},
							// required: ["allergiesNote"]
						},
						{
							properties: {
								allergies: {
									type: "array",
									maxItems: 0
								}
							}
						}
					]
				},

				petsPresent: {
					oneOf: [
						{
							properties: {
								petsPresent: { const: true },
								petDetails: {
									type: "array",
									title: "Pet Details",
									items: {
										type: "object",
										properties: {
											petType: {
												type: "string",
												title: "Pet Type",
												maxLength: 200,
												errorMessage: {
													maxLength: "Pet type must be 200 characters or less",
												}
											},
											petWeight: {
												type: "string",
												title: "Weight (lbs)",
												pattern: "^(?:\\s*|(?:[0-6]?\\d{1,2}|700)(?:\\.\\d{1,2})?)$",

												errorMessage: {
													pattern: "Enter a valid weight up to 700 lbs (max 2 decimal places)"
												}
											},
											size: { type: "string", title: "Size", enum: ["Small", "Medium", "Large"] },
										},
									},
								},
							},
						},
						{
							properties: {
								petsPresent: { const: false },
							},
						},
					],
				},
				longTermCareInsurance: {
					oneOf: [
						{
							properties: {
								longTermCareInsurance: { const: true },
								policyNumber: {
									type: "string",
									title: "Policy Number",
									minLength: 5,
									maxLength: 20,
									pattern: "^[A-Za-z0-9\\-]+$",
									errorMessage: {
										required: "Please enter policy number",
										minLength: "Policy number must be at least 5 characters",
										maxLength: "Policy number must not exceed 20 characters",
										pattern: "Policy number can only contain letters, numbers, and dashes"
									}
								},
								ltcInsuranceProvider: {
									type: "string",
									title: "Insurance Provider",
									minLength: 2,
									maxLength: 100,
									pattern: "^[A-Za-z .,&'-]+$",  // Letters, spaces, dots, ampersand, apostrophes
									errorMessage: {
										required: "Please enter insurance provider",
										minLength: "Insurance provider name must be at least 2 characters",
										maxLength: "Insurance provider name must not exceed 100 characters",
										pattern: "Provider name can only contain letters, spaces, and symbols like . , & ' -"
									}
								},
								ltcInsuranceAcknowledgment: {
									type: "boolean",
									title: "LTC Policy Acknowledgment",
									description: "I acknowledge that I have read and understand the LTC policy requirements and will provide all necessary documentation.",
									errorMessage: {
										required: "Please select insurance acknowledgment",
									}
								},
								learnMore: {
									type: "string",
									title: "",
									default: "Learn more about LTC insurance coverage "
								}
							},
							required: ["policyNumber", "ltcInsuranceProvider", "ltcInsuranceAcknowledgment"]
						},
						{
							properties: {
								longTermCareInsurance: { const: false }
							}
						}
					],
				},
				firearmsPresent: {
					oneOf: [
						{
							properties: {
								firearmsPresent: { const: true },
								firearmsSecure: {
									type: "string",
									title: "Are the firearms stored securely?",
									enum: ["No", "Yes"],
									errorMessage: {
										required: "Please select Yes or No",
									},
								},


							},
							required: ["firearmsSecure"]
						},
						{
							properties: {
								firearmsPresent: { const: false }
							}
						}
					],
				},
			},
		},
	},
};

export const serviceDetailUiSchema = {
	variableFlexibleServices: {
		"ui:order": [
			"bathing",
			"eating",
			'__spacer_assist_note',
			"assistanceEatingNotes",
			"toileting",
			"mealPreparation",
			"dressingGrooming",
			"housework",
			"companionship",
			"transportationNeeded",
			"other",
			"vehiclePreference",
			"specifyOther",
		],
		bathing: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		eating: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		__spacer_assist_note: {
			"ui:md": 6,
			"ui:widget": () => null,

		},
		assistanceEatingNotes: {
			"ui:md": 6,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 2
			},
			"ui:condition": (formData) => formData?.variableFlexibleServices?.eating === true,

		},
		transportationNeeded: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		dressingGrooming: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		housework: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		companionship: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		other: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		vehiclePreference: {
			"ui:md": 6,
			"ui:widget": "select",
			"ui:condition": (formData) => formData.additionalInformation?.transportationNeeded,
			"ui:enumNames": [
				"Caregiver's Vehicle",
				"Client's Vehicle",
				"Either Vehicle",
				"No Vehicle Required"
			],
		},
		specifyOther: {
			"ui:md": 6,
			"ui:widget": "text",
			"ui:condition": (formData) => formData?.variableFlexibleServices?.other === true,
		},
		toileting: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		mealPreparation: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
	},
	clientCareNeeds: {
		"ui:order": [
			"medicalDiagnosis",
			"fallRisk",
			'continence',
			"vision",
			"hearing",
			"speech",
			"oxygenDependent",
			"isShoweringAssistance",
			"isShoweringAssistanceLevel",
			"isMedicationReminders",
			"isMedicationRemindersResponse",
			"isOralHygieneAssistance",
			"walker",
			"isMealtimeAssistance",
			"isMealtimeAssistanceLevel",
			"swallowing",
			"dental",
			"swallowingOther",
		],
		medicalDiagnosis: {
			"ui:md": 12, "ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 2
			},
		},
		fallRisk: { "ui:md": 6, "ui:widget": "select", "ui:enumNames": ["None", "Low", "Medium", "High"] },
		continence: {
			"ui:md": 6, "ui:widget": "select", "ui:enumNames": [
				"Continent", "Occasional Issues", "Incontinent"
			],
		},
		vision: {
			"ui:md": 6, "ui:widget": "select", "ui:enumNames": [
				"Normal", "Impaired", "Blind"
			],
		},
		hearing: { "ui:md": 6, "ui:widget": "select", "ui:enumNames": ["Normal", "Mild Loss", "Moderate Loss", "Severe Loss", "Deaf"] },
		speech: { "ui:md": 6, "ui:widget": "select", "ui:enumNames": ["Normal", "Impaired", "Nonverbal"] },
		isShoweringAssistance: { "ui:md": 6, "ui:widget": "select" },
		isMedicationReminders: { "ui:md": 6, "ui:widget": "select" },
		isOralHygieneAssistance: { "ui:md": 6, "ui:widget": "select" },
		walker: { "ui:md": 6, "ui:widget": "select" },
		isMealtimeAssistance: { "ui:md": 6, "ui:widget": "select" },
		isMealtimeAssistanceLevel: { "ui:widget": "MultiSelectDropdown", "ui:md": 6, "ui:condition": (formData) => formData?.clientCareNeeds?.isMealtimeAssistance === "Yes" },
		dental: { "ui:md": 6, "ui:widget": "select" },
		swallowing: { "ui:md": 6, "ui:widget": "select" },
		isShoweringAssistanceLevel: { "ui:md": 6, "ui:widget": "select", "ui:condition": (formData) => formData?.clientCareNeeds?.isShoweringAssistance === "Yes" },
		isMedicationRemindersResponse: { "ui:md": 6, "ui:text": "select", "ui:condition": (formData) => formData?.clientCareNeeds?.isMedicationReminders === "Yes" },
		swallowingOther: { "ui:md": 6, "ui:widget": "text", "ui:condition": (formData) => formData?.clientCareNeeds?.swallowing === "Other" },
		oxygenDependent: { "ui:md": 6, "ui:widget": "select", "ui:enumNames": ["Yes", "No"] },
	},
	mobilityAssistanceHeading: {
		usesWheelchair: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},

		mobilityAssistance: { "ui:md": 6, "ui:widget": "select", "ui:enumNames": ["None", "Wheelchair", "Walker", "Cane", "Crutches", "Guide dog", "Both Walker & Cane"] },
	},
	behaviorCognition: {
		"ui:order": [
			"confusion",
			"confusionNotes",
			"agitation", "agitationNotes",
			"suspicious",
			"suspiciousNotes",
			"upAtNight", "upAtNightNotes",
			"withdrawn",
			"withdrawnNotes",
			"wanders", "wandersNotes",
			"combative", "combativeNotes"
		],

		confusion: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		confusionNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.confusion === true
		},

		agitation: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		agitationNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.agitation === true
		},

		suspicious: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		suspiciousNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.suspicious === true
		},

		upAtNight: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		upAtNightNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.upAtNight === true
		},

		withdrawn: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		withdrawnNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.withdrawn === true
		},

		wanders: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		wandersNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.wanders === true
		},

		combative: {
			"ui:md": 12,
			"ui:widget": "CardCheckboxWidget",
			"ui:options": { label: false }
		},
		combativeNotes: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:options": {
				rows: 1
			},
			"ui:condition": formData => formData?.behaviorCognition?.combative === true
		}
	},
	additionalInformation: {
		"ui:order": [
			"petsPresent",
			'smokingEnvironment',
			"petDetails",
			"longTermCareInsurance",
			"policyNumber",
			"ltcInsuranceProvider",
			"ltcInsuranceAcknowledgment",
			"learnMore",
			"allergies",
			"allergiesNote",
			"firearmsPresent",
			"firearmsSecure",
		],
		petsPresent: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		petDetails: {
			"ui:md": 12,
			"ui:field": "PetDetailsField",
			"ui:condition": (formData) => formData.additionalInformation?.petsPresent,
		},
		smokingEnvironment: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		longTermCareInsurance: {
			"ui:md": 12, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		ltcInsuranceProvider: {
			"ui:widget": "text",
			"ui:md": 6
		},
		policyNumber: {
			"ui:widget": "text",
			"ui:md": 6
		},
		ltcInsuranceAcknowledgment: {
			"ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		learnMore: {
			"ui:md": 6,
			"ui:widget": (props) => (
				<div style={{ display: "inline-block" }}>
					<a
						href="https://cambridgecaregivers.com/long-term-care-policy/"
						target="_blank"
						rel="noopener noreferrer"
						style={{ textDecoration: "underline", color: "#1976d2" }} // optional styling
					>
						{props.value}
					</a>
				</div>
			)
		},
		allergies: {
			"ui:md": 12, "ui:widget": "MultiSelectSearchDropdownWidget",
			"ui:options": {
				multiple: false
			}
		},

		allergiesNote: {
			"ui:md": 12,
			"ui:widget": "TextareaAutosizeWidget",
			"ui:condition": (formData) =>
				Array.isArray(formData?.additionalInformation?.allergies) &&
				formData.additionalInformation.allergies.length > 0,
			"ui:options": {
				rows: 2,
			},
		},

		firearmsPresent: {
			"ui:md": 6, "ui:widget": "CardCheckboxWidget", "ui:options": {
				label: false
			}
		},
		firearmsSecure: { "ui:md": 6, "ui:widget": "select", "ui:condition": (formData) => formData?.additionalInformation?.firearmsPresent === true },
	},
};